//After 15 min of inactivity the agent is logged out
export const INACTIVITY = 1000 * 60 * 15;
export const INACTIVITY_FOR_ADMIN = 1000 * 60 * 60 * 24;
